/**
 * `POST /v1/verifications/send` answers `429 VERIFICATION_CODE_ALREADY_SENT`
 * only when the persisted session still holds a provider-accepted, unexpired
 * code with attempts left. That is the one signal that guarantees the customer
 * can finish with the code they already have, so the booking OTP steps recover
 * into the code form instead of showing a failure.
 *
 * A bare 429 is the ordinary identifier/IP throttle and proves nothing about a
 * usable code, so clients branch on the structured code and never on the HTTP
 * status alone (`booking-verification.instructions.md` § Resend cooldown
 * signal). Same precedent as `ManageAppointment/CancelAppointment`.
 */
export function isVerificationCodeAlreadySentError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { code, status } = error as { code?: unknown; status?: unknown };
  return status === 429 && code === "VERIFICATION_CODE_ALREADY_SENT";
}
